import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import HomePage from "../pages/HomePage";
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";

const DashboardRouter = () => {
    return (
            <Routes>
                <Route element={<PersistLogin />}>
                    <Route element={<RequireAuth allowedRoles={["100"]} />}>
                        <Route path="/" element={<HomePage />} />
                        {/* <Route path="/create-proposal" element={<CapexForm />} /> */}
                        <Route path="*" element={<NotFound404 />} />
                    </Route>
                </Route>
            </Routes>
    )
}

export default DashboardRouter;